import React from 'react';

import { Paragraph } from '@zillow/constellation';

import PeopleInformation from './PeopleInformation';
import { PERSON_TYPE } from '../../../constants/stringConstants';
import type { PeopleSection } from '../../../models/index';

type Props = {
  section: PeopleSection;
  setSection: (section: PeopleSection) => void;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function LandlordInformation_v1({ section, setSection, setSectionValues }: Props): JSX.Element {
  const maxPeople = 1;

  return (
    <>
      <Paragraph fontType="h6" marginBottom="sm">
        Who is the landlord?
      </Paragraph>
      <PeopleInformation
        isOptional={false}
        maximumPeople={maxPeople}
        personType={PERSON_TYPE.LANDLORD}
        setSectionValues={setSectionValues}
        setSection={setSection}
        section={section}
        addressLabel="Address"
      />
    </>
  );
}
